import { FC, useEffect } from 'react';

import { getSelectedNamedSnippets, getSelectedSnippets } from '@features/snippetsSlice';
import useTranslateSnippets from '@hooks/useTranslateSnippets';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderSnippets: FC = () => {
  const selectedSnippets = useSelector(getSelectedSnippets);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateSnippets();
  const navigate = useNavigate();

  const namedSelected = useSelector(getSelectedNamedSnippets);

  useEffect(() => {
    if (!selectedSnippets || !selectedSnippets.length) navigate(ROUTES.EMAILS);
  }, [selectedSnippets, navigate]);

  return (
    <NewOrderBase
      type={'snippets'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedSnippets}
      onSend={(data) => mutateAsync({ ...data, ids: selectedSnippets })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderSnippets;
